/**
 * Construct a title from a base part and a numeric suffix.
 * @param titleBase
 * @param titleNumber
 * @returns numbered title
 */
export function defaultTitle(titleBase, titleNumber) {
    return `${titleBase} ${titleNumber}`;
}
/**
 * Return the base part of a title, with any trailing number stripped off.
 * @param title any string
 * @returns title base, which will be an initial substring of the title
 *   or the whole title if there was no numeric suffix.
 */
export function extractTitleBase(title) {
    const match = title.match(/^(.*?)( *\d+)?$/);
    return (match === null || match === void 0 ? void 0 : match[1]) || "";
}
/**
 * Check if a title is constructed in the standard fashion as a base, optionally followed by a number.
 * @param title string to check
 * @param titleBase the base title part to check for
 * @returns a RegExp match object or null; the first group of the match is the number suffix (if any).
 */
export function titleMatchesDefault(title, titleBase) {
    if (title) {
        return title.match(new RegExp(`^${titleBase} *(\\d*)$`));
    }
    else {
        return null;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGl0bGUtdXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbGl0aWVzL3RpdGxlLXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLFlBQVksQ0FBQyxTQUFpQixFQUFFLFdBQW1CO0lBQ2pFLE9BQU8sR0FBRyxTQUFTLElBQUksV0FBVyxFQUFFLENBQUM7QUFDdkMsQ0FBQztBQUVEOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLEtBQWE7SUFDNUMsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDO0lBQzdDLE9BQU8sQ0FBQSxLQUFLLGFBQUwsS0FBSyx1QkFBTCxLQUFLLENBQUcsQ0FBQyxDQUFDLEtBQUksRUFBRSxDQUFDO0FBQzFCLENBQUM7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sVUFBVSxtQkFBbUIsQ0FBQyxLQUFjLEVBQUUsU0FBa0I7SUFDcEUsSUFBSSxLQUFLLEVBQUUsQ0FBQztRQUNWLE9BQU8sS0FBSyxDQUFDLEtBQUssQ0FBQyxJQUFJLE1BQU0sQ0FBQyxJQUFJLFNBQVMsV0FBVyxDQUFDLENBQUMsQ0FBQztJQUMzRCxDQUFDO1NBQU0sQ0FBQztRQUNOLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztBQUNILENBQUMifQ==